module.exports = __webpack_public_path__ + "static/img/guanli.143d7c5c.png";